import { AgentRunEvent } from '@lucidtech/las-sdk-browser';
import { FunctionComponent, memo, ReactNode } from 'react';

import { DateTime, Heading, Tooltip, TooltipTrigger } from '@/components/core';

export type EventTooltipBodyProps = {
  event: AgentRunEvent;
  agentId: string;
  runId: string;
};

export type EventTooltipProps = {
  event: AgentRunEvent;
  agentId: string;
  runId: string;
  heading?: string | null;
  Body?: FunctionComponent<EventTooltipBodyProps> | null;
  timestamp?: Date | null;
  icon: ReactNode;
};

const IEventTooltip = ({ event, agentId, runId, heading, Body, timestamp, icon }: EventTooltipProps) => {
  return (
    <TooltipTrigger>
      <Tooltip variant="primary" className="gap-sm flex w-48 flex-col">
        <Heading className="border-b border-gray-700 pb-1" size="xs">
          {heading}
        </Heading>
        {Body ? <Body event={event} agentId={agentId} runId={runId} /> : null}
        <DateTime date={timestamp} disableTooltip className="!font-regular !text-gray-400" />
      </Tooltip>
      {icon}
    </TooltipTrigger>
  );
};

export const EventTooltip = memo(IEventTooltip) as typeof IEventTooltip;
